import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type { PropsWithChildren } from 'react';
import type { ThemeProps } from '~/_shared/types/themeProps';

const accordionStyle = ({ theme }: ThemeProps) => css({
  color: theme.textColors.primary,
  fontFamily: '"Work Sans", sans-serif',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '16px',
  width: '100%',
  counterReset: 'accordion-item',
});

export const Accordion = styled.div<PropsWithChildren>(accordionStyle);
